import { render, staticRenderFns } from "./SupercardProfile.vue?vue&type=template&id=188c22cc&"
import script from "./SupercardProfile.vue?vue&type=script&lang=js&"
export * from "./SupercardProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports